import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import App from './App';
import { RuntimeQueryProvider } from './contexts/RuntimeQueryProvider';
import { RuntimeOperationProvider } from './contexts/RuntimeOperationProvider';
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <RuntimeQueryProvider>
      <RuntimeOperationProvider>
        <Router>
          <App />
        </Router>
      </RuntimeOperationProvider>
    </RuntimeQueryProvider>
  </React.StrictMode>
);
